import React, { useState, useEffect, useContext } from "react";
import { Checkbox } from "antd";
import { AppContext } from "../../context";

function ExtraSelection({
  product,
  extraReservationConfig,
  setExtraReservationConfig,
}) {
  const [total, setTotal] = useState(0);
  const info = useContext(AppContext);

  useEffect(() => {
    if (extraReservationConfig.length) {
      let days = info?.rentacar?.days;
      // if (info?.rentacar?.return_date && info?.rentacar?.pickup_date) {
      //   const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      //   const date1 = new Date(info?.rentacar?.pickup_date);
      //   const date2 = new Date(info?.rentacar?.return_date);
      //   const utc1 = Date.UTC(
      //     date1.getFullYear(),
      //     date1.getMonth(),
      //     date1.getDate()
      //   );
      //   const utc2 = Date.UTC(
      //     date2.getFullYear(),
      //     date2.getMonth(),
      //     date2.getDate()
      //   );

      //   days = Math.floor((utc2 - utc1) / _MS_PER_DAY);
      // }
      let total = 0;
      for (const extra of extraReservationConfig) {
        let valueOfExtra = days * parseFloat(extra.price || 0);
        if (parseFloat(extra.max_value) > 0) {
          valueOfExtra =
            valueOfExtra > parseFloat(extra.max_value)
              ? parseFloat(extra.max_value)
              : valueOfExtra;
        }
        total += valueOfExtra;
      }
      setTotal(total);
    }
  }, [extraReservationConfig]);

  // sort extras

  product?.ren_extras.sort((a, b) =>
    a.name?.[info.language || "pt"] > b.name?.[info.language || "pt"] ? 1 : -1
  );

  return product?.ren_extras && product?.ren_extras.length > 0 ? (
    <div>
      {/* EXTRAS */}
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        {info.t("selectExtras")}
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <table>
          <tr>
            <th style={{ width: 200, textAlign: "left" }}>{info.t("extra")}</th>
            <th style={{ width: 80, textAlign: "right" }}>{info.t("value")}</th>
            <th style={{ width: 80, textAlign: "right" }}>
              {info.t("maximum")}
            </th>
          </tr>

          {product?.ren_extras.map((extra, index) => (
            <tr
              style={{
                backgroundColor: index % 2 === 0 ? "rgb(238,238,228)" : "",
              }}
              key={extra.id}
            >
              <td>
                <Checkbox
                  onChange={(e) => {
                    setExtraReservationConfig(
                      e.target.checked
                        ? [
                            ...extraReservationConfig.filter(
                              (v) => v.id !== extra.id
                            ),
                            extra,
                          ]
                        : [
                            ...extraReservationConfig.filter(
                              (v) => v.id !== extra.id
                            ),
                          ]
                    );
                  }}
                  key={extra.id}
                >
                  {extra.name?.[info.language] || extra.name?.["pt"]}
                </Checkbox>
              </td>
              <td style={{ width: 60, textAlign: "right" }}>
                {extra.price || "0"} €
              </td>
              <td style={{ width: 60, textAlign: "center" }}>
                {(extra.max_value && extra.max_value + "€") || "-"}
              </td>
            </tr>
          ))}
        </table>
      </div>

      {/* Preço dos Extras */}
      {extraReservationConfig.length > 0 && (
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <table>
            <tr>
              <td style={{ textAlign: "right" }}>
                <strong>{info.t("total")}:</strong>
              </td>
              <td style={{ textAlign: "right" }}>
                <strong>{total} €</strong>
              </td>
            </tr>
          </table>
        </div>
      )}
    </div>
  ) : (
    <div></div>
  );
}

export default React.memo(ExtraSelection);
